import Timestamp from "components/Timestamp";
import Callout from "ds/components/Callout";
import { Stack } from "types/generated";
import { Lock } from "components/icons/generated";

type StackLockNoticeProps = {
  lockedAt: Stack["lockedAt"];
  lockedBy: Stack["lockedBy"];
  note?: Stack["lockNote"];
  viewer: string;
};

const StackLockNotice = ({ lockedAt, lockedBy, note, viewer }: StackLockNoticeProps) => (
  <Callout
    icon={Lock}
    title={
      <>
        This stack was locked for exclusive use by {lockedBy === viewer ? "yourself" : lockedBy}
        {lockedAt && (
          <>
            &nbsp;on&nbsp;
            <Timestamp timestamp={lockedAt} />
          </>
        )}
        .
      </>
    }
    variant="warning"
  >
    {note && <>{note}</>}
  </Callout>
);

export default StackLockNotice;
